module.exports = __webpack_public_path__ + "static/media/Gemstone-Report-2.de680b6c.jpg";